var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChatRoundMark = function SvgChatRoundMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42.415
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6919",
    transform: "translate(7.486 6.455)",
    fill: "#102b3f"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 316",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(-7.486 -6.455)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3251",
    d: "M-7.341 15.155v20.8l16.026-6.1Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6922"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6384",
    fill: "none",
    stroke: "#e8f5f5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6375",
    transform: "translate(10.21 12.386)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3388",
    d: "M1.484 8.162 0 8.806v4.509a3.925 3.925 0 0 0 3.925 3.924h3.831a3.925 3.925 0 0 0 3.925-3.924V8.806L7.647 7.054"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 319",
    cx: 3.767,
    cy: 3.767,
    transform: "translate(2.073)",
    r: 3.767
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6376",
    transform: "translate(22.749 12.386)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3389",
    d: "M1.852 17.239h3.831a3.925 3.925 0 0 0 3.925-3.924V8.806L5.574 7.054"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 320",
    cx: 3.767,
    cy: 3.767,
    r: 3.767
  }))))));
};
export default SvgChatRoundMark;